var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderResult"},[_c('OrderResultBlock',{ref:"OrderResultBlock",staticClass:"mt-32",attrs:{"order":_vm.order},on:{"reFetch":_vm.getOrder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }